module.exports = __webpack_public_path__ + "static/Doctor_Patient_mobile_new-4e6d59099bb81aecabac5b2604b90452.png";